import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
import { ReturnedHoverProps, Props } from './types';
export { ReturnedHoverProps, Props };
export default function useHover() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$mouseEnterDelayM = _ref.mouseEnterDelayMS,
    mouseEnterDelayMS = _ref$mouseEnterDelayM === void 0 ? 0 : _ref$mouseEnterDelayM,
    _ref$mouseLeaveDelayM = _ref.mouseLeaveDelayMS,
    mouseLeaveDelayMS = _ref$mouseLeaveDelayM === void 0 ? 0 : _ref$mouseLeaveDelayM;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovering = _useState2[0],
    setIsHovering = _useState2[1];
  var mouseEnterTimer;
  var mouseOutTimer;
  var hoverProps = {
    onMouseEnter: function onMouseEnter() {
      clearTimeout(mouseOutTimer);
      mouseEnterTimer = setTimeout(function () {
        return setIsHovering(true);
      }, mouseEnterDelayMS);
    },
    onMouseLeave: function onMouseLeave() {
      clearTimeout(mouseEnterTimer);
      mouseOutTimer = setTimeout(function () {
        return setIsHovering(false);
      }, mouseLeaveDelayMS);
    }
  };
  return [isHovering, hoverProps];
}